import baseCalculations from '../base';

export default {
  ...baseCalculations,
};
